// Parent studio parity (owner decision 2026-08-24): a signed-in PARENT may
// enter the kid project STUDIO routes for their own kids' projects with full
// read-write functionality — view, edit, save, run, AI turns on the family
// wallet. Studio hubs also support the adult’s own creations; the rest of the Learn shell
// (/learn home, projects, classes, missions, passport…) stays kid-only.
//
// The server remains the authz source of truth (CLAUDE.md §4): this list only
// decides which routes a parent session may RENDER — a cross-family project
// still 403/404s on every backend call and lands on the existing error UX.

/** Adult creation is allowed in the live Studio hubs and their editors.
 * General Learn home, classes, missions and child project lists stay kid-only. */
export function isParentStudioPath(pathname: string): boolean {
  return (
    /^\/learn\/(playground|blocks|code|video)\/[^/]+/.test(pathname) ||
    /^\/learn\/create\/(image(?:\/canvas)?|blocks|video)\/?$/.test(pathname) ||
    /^\/learn\/music(?:\/[^/]+)?\/?$/.test(pathname)
  );
}

/** Portal intent selects the adult session; the server enforces ownership. */
export function isExplicitParentStudio(pathname: string, search: string): boolean {
  return isParentStudioPath(pathname) && new URLSearchParams(search).get('actor') === 'parent';
}

export function parentStudioHref(href: string): string {
  const [pathname, query = ''] = href.split('?');
  if (!isParentStudioPath(pathname)) return href;
  const params = new URLSearchParams(query);
  params.set('actor', 'parent');
  return `${pathname}?${params.toString()}`;
}
